<template>
    <div class="homepage__topics-covered">
        <h2 class="covered-topics__title" v-html="$t('lp.topics.title')" />
        <p
            class="covered-topics__description"
            v-html="$t('lp.topics.description')"
        />
        <div class="covered-topics__slider">
            <OldCarousel :settings="settings" class="carousel">
                <Slide
                    v-for="(imgPath, index) in [...topicImages, ...topicImages]"
                    :key="index"
                    class="slide"
                >
                    <img
                        :src="
                            checkMobile
                                ? `${imgPath}-mobi.svg`
                                : `${imgPath}.svg`
                        "
                        :onerror="`this.onerror=null;this.src='${
                            checkMobile
                                ? `${fallbackImages[index]}-mobi.svg`
                                : `${fallbackImages[index]}.svg`
                        }'`"
                        alt="Topic"
                    />
                </Slide>
                <template #addons>
                    <Navigation />
                    <Pagination />
                </template>
            </OldCarousel>
        </div>
    </div>
</template>

<script>
import {
    Carousel as OldCarousel,
    Slide,
    Pagination,
    Navigation,
} from 'vue3-carousel';
import { isMobileScreenWidth } from '@/core/helpers/MobileHelpers';
export default {
    components: {
        OldCarousel,
        Slide,
        Pagination,
        Navigation,
    },
    data() {
        return {
            settings: {
                itemsToShow: 1,
                snapAlign: 'center',
            },
        };
    },
    computed: {
        fallbackImages() {
            const imagePath = '/images/lp/slides/en/';

            return [
                imagePath + '1',
                imagePath + '2',
                imagePath + '3',
                imagePath + '1',
            ];
        },
        topicImages() {
            const imagePath = `/images/lp/slides/${this.$i18n.locale}/`;

            if (this.checkMobile) {
                return [
                    imagePath + '1',
                    imagePath + '2',
                    imagePath + '3',
                    imagePath + '4',
                ];
            }

            return [imagePath + '1', imagePath + '2', imagePath + '3'];
        },
        checkMobile() {
            return isMobileScreenWidth();
        },
    },
    mounted() {
        setTimeout(() => {
            this.$forceUpdate();
        }, 800);
    },
};
</script>

<style scoped lang="scss">
.homepage__topics-covered {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 1rem 2rem;
    width: 100%;
    box-sizing: border-box;
    position: relative;

    &::before {
        content: '';
        display: block;
        width: 100%;
        background-color: #a166f0;
        position: absolute;
        left: 0;
        z-index: 1;
        transform: skewY(4deg);
        top: -50px;
        height: 90px;

        @include mq($w-min-desktop, min) {
            transform: skewY(2deg);
        }
    }

    &::after {
        content: '';
        display: block;
        width: 100%;
        background-color: #a166f0;
        position: absolute;
        left: 0;
        z-index: 1;
        transform: skewY(-4deg);
        bottom: -35px;
        height: 55px;

        @include mq($w-min-tablet, min) {
            height: 75px;
        }

        @include mq($w-min-desktop, min) {
            transform: skewY(-2deg);
            bottom: -35px;
        }

        @include mq($w-min-wide-desktop, min) {
            height: 125px;
        }
    }
    .covered-topics {
        &__title {
            margin: 2rem 0 0;
            font-style: normal;
            font-weight: bold;
            font-size: 1.5rem;
            line-height: 1.8125rem;
            text-align: center;
            max-width: 815px;

            @include mq($w-min-md, min) {
                padding-top: 1rem;
                font-size: 2rem;
                line-height: 130%;
            }
        }

        &__description {
            font-style: normal;
            font-weight: normal;
            font-size: 1.3rem;
            line-height: 120%;
            text-align: center;
            margin: 1rem 0 0;
            max-width: 1000px;

            @include mq($w-max-sm, max) {
                font-size: 1.5rem;
                line-height: 1.8125rem;
            }
        }

        &__slider {
            max-width: 60%;
            margin-top: -1rem;

            @include mq($w-min-md, min) {
                margin-top: -3.5rem;
            }

            @include mq($w-max-sm, max) {
                max-width: 88%;
            }

            img {
                width: 100%;
                height: 70%;
                min-width: 200px;
                margin-top: 10%;

                @include mq($w-max-sm, max) {
                    height: 90%;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.slide {
    z-index: 4;
}
</style>
